import React from 'react';

import { Artwork as ArtworkCell } from '../common/container/Cell.jsx';
import { ArtworkGridContainer, Spaced, forResource } from '../common/container/Container.jsx';
import { withSubmission } from '../common/container/Form.jsx';
import { Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { Popup } from '../common/container/Popup.jsx';
import { Button } from '../common/input/Button.jsx';
import Arrows from '../common/input/Arrows.jsx';
import { Input } from '../common/input/Text.jsx';

class _List extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            artwork: {
                dir: 1,
                limit: 20,
                loading: false,
                offset: 0,
                order: 2
            }
        };

        this.getArtwork = this.getArtwork.bind(this);
        this.handleArtworkWaypointEnter = this.handleArtworkWaypointEnter.bind(this);
        this.handleInvite = this.handleInvite.bind(this);
        this.handleInviteClose = this.handleInviteClose.bind(this);
    }

    componentDidMount() {
        const component = this;
        component.props.onRegisterRequestCallback(function (responseData) {
            Artcloud.mkt.profiles._isfollowing(responseData);

            const user = Artcloud.auth.user;
            responseData.MyAccount = false;
            if (user && responseData.Profile && user.UserId === responseData.Profile.ProfileId) {
                responseData.MyAccount = true;
            }

            component.getArtwork(responseData.ListId);
        });
    }

    componentWillUnmount() {
        if (this.artworkRequest) {
            this.artworkRequest.abort();
            this.artworkRequest = null;
        }
    }

    getArtwork(listId) {
        const component = this;
        const state = component.state.artwork;
        if (state.loading) {
            return;
        }
        state.loading = true;
        component.setState({
            artwork: state
        });
        component.artworkRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.lists.art.get(listId),
            { dir: state.dir, limit: state.limit, offset: state.offset, order: state.order },
            function (responseData) {
                component.artworkRequest = null;

                let data = state.data || [];
                state.data = data.concat(responseData.Art);

                state.offset += responseData.Art.length;
                state.total = responseData.Total;

                state.loading = false;
                component.setState({
                    artwork: state
                });
            },
            function (jqXHR, textStatus) {
                component.artworkRequest = null;

                if (!state.data) {
                    state.data = [];
                }
                state.loading = false;
                component.setState({
                    artwork: state
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    handleArtworkWaypointEnter() {
        if (!this.state.artwork.data || (this.state.artwork.data && this.state.artwork.offset >= this.state.artwork.total)) {
            return;
        }
        this.getArtwork(this.props.data.ListId);
    }

    handleInvite() {
        this.setState({
            inviteModal: true
        });
    }

    handleInviteClose() {
        this.setState({
            inviteModal: undefined
        });
    }

    render() {
        const data = this.props.data || {};
        return (
            <React.Fragment>
                {
                    !this.props.data &&
                    <LoadingIndicator />
                }
                <div className="header--highlight header--btns">
                    <div className="container">
                        <h1>{data.Name}</h1>

                        <div className="header__btns">
                            {
                                data.MyAccount &&
                                <Button config={{ size: 'lg', style: 'neat' }} onClick={this.handleInvite}>
                                    <React.Fragment><span className="i i--invite" /> Invite friends</React.Fragment>
                                </Button>
                            }
                        </div>
                    </div>
                </div>
                <Spaced className="spacer--bottom section">
                    {
                        this.state.artwork.data &&
                        this.state.artwork.data.length == 0 &&
                        <NoResults display="No Artwork" />
                    }
                    <ArtworkGridContainer sizeClassName="art__container grid--3" onWaypointEnter={this.handleArtworkWaypointEnter}>
                        {
                            this.state.artwork.data &&
                            this.state.artwork.data.length > 0 &&
                            this.state.artwork.data.map((d, i) => <ArtworkCell key={i} className="grid--3" d={d} cols={4}/>)
                        }
                    </ArtworkGridContainer>
                    {
                        this.state.artwork.loading &&
                        <LoadingIndicator />
                    }
                </Spaced>
                {
                    this.state.inviteModal &&
                    <ListInvite data={this.props.data} onClose={this.handleInviteClose} />
                }
            </React.Fragment>
        );
    }
}

let _ListInviteInst;
class ListInvite extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true
        };

        this.getInvites = this.getInvites.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        _ListInviteInst = true;

        this.getInvites();
    }

    componentWillUnmount() {
        _ListInviteInst = undefined;

        if (this.request) {
            this.request.abort();
            this.request = null;
        }
    }

    getInvites() {
        if (!this.props.data) {
            return;
        }
        const component = this;
        if (component.request) {
            component.request.abort();
            component.request = null;
        }
        component.request = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.lists.invites.get(component.props.data.ListId),
            null,
            function (responseData) {
                component.request = null;

                component.setState({
                    invites: responseData.Invites,
                    loading: false
                });
            },
            function () {
                component.request = null;
                component.setState({
                    invites: component.state.invites || [],
                    loading: false
                });
            }
        );
    }

    handleChange(name, value) {
        this.setState({
            [name]: value
        });
    }

    handleClose(event) {
        if (event) {
            event.preventDefault();
        }
        if (!this.state.loading && this.props.onClose) {
            this.props.onClose();
        }
    }

    handleSubmit(data, callback) {
        const component = this;
        component.setState({
            loading: true
        });
        Artcloud.api.put(
            Artcloud.url.vendor.marketplace.lists.invites.put(component.props.data.ListId),
            { Email: data.Email },
            function () {
                if (!_ListInviteInst) {
                    return;
                }
                component.getInvites();
                if (callback) {
                    callback(true, 'Your invitation has been sent!');
                }
            },
            function (jqXHR) {
                if (!_ListInviteInst) {
                    return;
                }
                component.setState({
                    loading: false
                });
                if (!callback) {
                    return;
                }
                callback(false, 'Error sending invitation.', jqXHR);
            }
        );
    }

    render() {
        const data = this.props.data || {};
        return (
            <Popup className="popup--invite" type='popup' onClose={this.handleClose}>
                <h2 className="popup__title">Invite friends to list</h2>
                <h5 className="popup__label" style={{ marginBottom: '10px' }}>Share <strong>{data.Name}</strong> with your friends</h5>
                <ShareForm clearOnSubmit={true} onSubmit={this.handleSubmit} />
                <div className="user__list">
                    {
                        this.state.loading &&
                        <LoadingIndicator />
                    }
                    {
                        this.state.invites &&
                        (this.state.invites.map((d) => <UserListItem key={d.ProfileId} d={d} />))
                    }
                </div>
            </Popup>
        );
    }
}

function _ShareForm(props) {
    return (
        <div className="input--popup">
            <Input
                config={{ color: 'light', size: 'small', style: 'outline' }}
                name="Email"
                placeholder="Email Address"
                required
                type="email"
                value={props.state.Email}
                onChange={props.onChange} />
            <Arrows config={{ color: 'light' }} display="Submit" form={true} />
        </div>
    )
}
const ShareForm = withSubmission(_ShareForm);

function UserListItem(props) {
    return (
        <div className="user__list__item">
            <div className="user__img--small" style={{ backgroundColor: 'transparent' }}>
                {
                    props.d.Image &&
                    <img src={props.d.Image.SmallUrl} alt={props.d.Name} />
                }
            </div>
            <div className="user__list__text">{props.d.Name}</div>
        </div>
    )
}

const List = forResource(_List, Artcloud.url.vendor.marketplace.lists.get);
export default List;